import React, { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { useNavigate, useParams } from 'react-router-dom';
import MainCard from '../cards/MainCard';
import {
    Autocomplete,
    Button,
    Grid,
    Popper,
    TextField,
    FormControlLabel,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    Checkbox
} from '@mui/material';
import toast from 'react-hot-toast';
import { isEmpty, isValidPhoneNumber, validateAmount, validateEmail } from '../../utils/validator';
import { get, post, put } from '../../axios/apiService';
import LoadingBackdrop from '../full-screen-loadder/LoadingBackdrop';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import styled from '@emotion/styled';
import countries from '../../utils/countries_states.json';
import dayjs from 'dayjs';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import parsePhoneNumberFromString from 'libphonenumber-js';
import { Controller, useForm } from 'react-hook-form';
import { useMemo } from 'react';

const CustomPopper = styled(Popper)({
    '& .MuiAutocomplete-paper': {
        backgroundColor: '#f5f5f5',
        color: '#000'
    }
});

function AddEditPlanForm({ title = '' }) {
    const theme = useTheme();
    const id = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);

    const { control, handleSubmit, getValues, reset, watch } = useForm({
        defaultValues: {
            id: '',
            name: '',
            tenureInDays: 0,
            price: 0,
            isTrail: false,
        }
    });

    const [planDetail, setPlanDetail] = useState({
        givenName: '',
        displayName: '',
        emailId: '',
        mobileNumber: '',
        city: '',
        country: null,
        state: null,
        postalCode: '',
        dateOfBirth: null,
        gender: '',
        address: "",
        changePasswordOnNextSignIn: false
    });

    const [formErrors, setFormErrors] = useState({});
    const [isValidation, setIsValidation] = useState(false);

    const watchedFields = [
        'name',
        'price',
        'tenureInDays',
    ];

    const formValues = useMemo(() =>
        watchedFields.reduce((acc, field) => {
            acc[field] = watch(field);
            return acc;
        }, {}),
        watchedFields.map(watch)
    );

    useEffect(() => {
        if (isValidation) {
            validator(formValues);
        }
    }, [formValues, isValidation]);

    useEffect(() => {
        if (id.id != undefined && id.id != null) {
            getByIdPlan();
        }
    }, [id]);

    const getByIdPlan = async () => {
        setIsLoading(true);
        try {
            let response = await get(`Plan/${id.id}`, null);
            if (response != null) {
                console.log("response.............", response);
                reset({
                    id: response.id,
                    name: response.name,
                    tenureInDays: response.tenureInDays,
                    price: response.price,
                    isTrail: response.isTrail,
                });
            }
        } catch (err) {
            console.error(err.message);
            toast.error(err.response.data);
        } finally {
            setIsLoading(false);
        }
    }


    const onSubmit = async (data) => {
        console.log("data,....", data);
        console.log("getValues.............", getValues());
        setIsValidation(true);
        if (!validator()) return;
        setIsValidation(true);
        const apiUrl = id.id != null && id.id != undefined ? `Plan/${id.id}` : 'Plan';
        console.log("id.........", id);

        try {
            setIsLoading(true);

            let param = {
                name: data.name,
                tenureInDays: data.tenureInDays,
                price: data.price,
                isTrail: data.isTrail
            }
            console.log("param.........", param);
            let response = id.id != null && id.id != undefined ? await put(apiUrl, param) : await post(apiUrl, param);
            // let response = await post(apiUrl, param);

            if (response) {
                toast.success(id.id != null && id.id != undefined ? 'Plan updated successfully' : 'Plan added successfully');
            }
            navigate('/plan-management');
        } catch (error) {
            toast.error('Failed to save policy. Please try again.');
        } finally {
            setIsLoading(false);
            setIsValidation(false);
        }
    };
    const validator = () => {
        let data = getValues();
        const errors = {};
        if (isEmpty(data?.name)) {
            errors.name = "Please enter name";
        }

        if (isEmpty(data?.name)) {
            errors.givenName = "Please enter name";
        }

        if (!validateAmount(data?.price, 1)) {
            errors.price = "Please enter a valid price greater than or equal to 1.";
        }

        if (!validateAmount(data?.tenureInDays, 1)) {
            errors.tenureInDays = "Please enter a valid tenureInDays greater than or equal to 1.";
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };



    return (
        <div>
            <MainCard title={title} backButton={{ onClick: () => navigate('/plan-management') }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>

                        {/* Plan Information Section */}
                        <Grid item xs={12}>
                            <fieldset style={{
                                border: '2px solid #364152',
                                borderRadius: '8px',
                                padding: '20px',
                                marginBottom: '20px',
                            }}>
                                <legend style={{
                                    color: '#364152',
                                    fontSize: '1.2em',
                                    padding: '0 10px',
                                    fontWeight: 'bold',
                                    backgroundColor: '#f0f0f0',
                                    borderRadius: '5px',
                                }}>
                                    Plan Information
                                </legend>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name="name"
                                                control={control}
                                                render={({ field }) => <TextField {...field} label="Plan Name" />}
                                            />
                                            <div style={{ color: 'red' }}>{formErrors.name}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name="tenureInDays"
                                                control={control}
                                                render={({ field }) => <TextField {...field} label="Plan TenureInDays" type="number" onChange={(e) => field.onChange(parseInt(e.target.value, 10) || 0)} />}
                                            />
                                            <div style={{ color: 'red' }}>{formErrors.tenureInDays}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl fullWidth>
                                            <Controller
                                                name="price"
                                                control={control}
                                                render={({ field }) => <TextField {...field} label="Plan Price" type="number" onChange={(e) => field.onChange(parseInt(e.target.value, 10) || 0)} />}
                                            />
                                            <div style={{ color: 'red' }}>{formErrors.price}</div>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <FormControl fullWidth>
                                            <FormControlLabel
                                                control={
                                                    <Controller
                                                        name="isTrail"
                                                        control={control}
                                                        render={({ field }) => (
                                                            <Checkbox
                                                                {...field}
                                                                checked={field.value || false} // Ensure `checked` is boolean
                                                                onChange={(e) => field.onChange(e.target.checked)} // Handle boolean value
                                                            />
                                                        )}
                                                    />
                                                }
                                                label="Plan Trail"
                                            />

                                            <div style={{ color: 'red' }}>{formErrors.trail}</div>
                                        </FormControl>
                                    </Grid>
                                </Grid>

                            </fieldset>
                        </Grid>
                    </Grid>

                    <Button type="submit" variant="contained" sx={{ marginTop: '20px', padding: '5px 30px' }} >
                        Save
                    </Button>
                </form>
            </MainCard>


            <LoadingBackdrop open={isLoading} />
        </div>
    );
}
export default AddEditPlanForm;
